export default {
    format: 'DD-MM-YYYY',
    i18n: {
        previousMonth : 'Vorige maand',
        nextMonth     : 'Volgende maand',
        months        : ['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'],
        weekdays      : ['Zondag','Maandag','Dinsdag','Woensdag','Donderdag','Vrijdag','Zaterdag'],
        weekdaysShort : ['Zo','Ma','Di','Wo','Do','Vr','Za']
    },
    yearRange: [1900,2030],
    theme: 'rea-theme'
};
